const hundred = 100
const two = 2

export const formatPriceForDataLayer = (price) => {
  return price ? (price / hundred).toFixed(two) : price
}
